export class LoadingStates {
  constructor() {
    this.states = new Map();
  }

  setLoading(element, isLoading = true) {
    if (isLoading) {
      element.classList.add('pixl-search-loading');
      element.setAttribute('aria-busy', 'true');
      this.states.set(element, true);
    } else {
      element.classList.remove('pixl-search-loading');
      element.setAttribute('aria-busy', 'false');
      this.states.delete(element);
    }
  }

  isLoading(element) {
    return this.states.has(element);
  }

  clearAll() {
    this.states.forEach((_, element) => {
      this.setLoading(element, false);
    });
  }
}